/** Shared entrance animation for question containers */
export const QUESTION_ENTER_ANIMATION =
  'animate-in fade-in slide-in-from-bottom-4 space-y-6 duration-300';

/** Base classes for selectable option buttons */
export const OPTION_BUTTON_BASE =
  'w-full rounded-lg border p-4 text-left transition-all';
